/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { HistInfoMeta } from './histInfoMeta';
import { PersonStammMasterListEntryMeta } from './personStammMasterListEntryMeta';


export interface CapititelEntryMeta { 
    anmelder?: Array<PersonStammMasterListEntryMeta>;
    mAnmelder?: FieldMetaData;
    austragDatum?: Date;
    mAustragDatum?: FieldMetaData;
    titelIndex?: number;
    mTitelIndex?: FieldMetaData;
    erstellAmtNummer?: number;
    mErstellAmtNummer?: FieldMetaData;
    titelName?: string;
    mTitelName?: FieldMetaData;
    titelJahr?: number;
    mTitelJahr?: FieldMetaData;
    eintragDatum?: Date;
    mEintragDatum?: FieldMetaData;
    pfandtitelStatus?: CapititelEntryMeta.PfandtitelStatusEnum;
    mPfandtitelStatus?: FieldMetaData;
    histInfo?: HistInfoMeta;
    mHistInfo?: FieldMetaData;
}
export namespace CapititelEntryMeta {
    export type PfandtitelStatusEnum = 'UNBEKANNT' | 'EINGETRAGEN' | 'AUSGETRAGEN' | 'ERSTELLT';
    export const PfandtitelStatusEnum = {
        UNBEKANNT: 'UNBEKANNT' as PfandtitelStatusEnum,
        EINGETRAGEN: 'EINGETRAGEN' as PfandtitelStatusEnum,
        AUSGETRAGEN: 'AUSGETRAGEN' as PfandtitelStatusEnum,
        ERSTELLT: 'ERSTELLT' as PfandtitelStatusEnum
    };
}


